import capitalize from "../../../helpers/capitalize";

export default function getOverviewMetricData(label: string) {
  let tooltip;
  let conversionKey;
  let title = capitalize(label);
  let subTitle;

  switch (label) {
    case "avg case delays":
      tooltip = "Avg_Case_Delay_Tooltip";
      conversionKey = "intlMins";
      title = "Avg Case Delay";
      break;
    case "ot utilization":
      tooltip = "OT_Utilization_Tooltip";
      conversionKey = "intlPercent";
      title = "OT Utilization";
      break;
    case "fcots":
      tooltip = "FCOTS_Tooltip";
      conversionKey = "intlPercent";
      title = "FCOTS";
      break;
    case "case on time & early":
      tooltip = "Cases_On_Time_Early_Tooltip";
      conversionKey = "intlPercent";
      break;
    case "on time starts (all cases)":
      tooltip = "Cases_On_Time_Early_Tooltip";
      conversionKey = "intlPercent";
      title = "On_Time_Starts";
      break;
    case "on time ends (all cases)":
      tooltip = "On_Time_Ends_Tooltip";
      conversionKey = "intlPercent";
      title = "On_Time_Ends";
      break;
    case "total cases":
      tooltip = "Total_Cases_Tooltip";
      conversionKey = "intlNumber";
      break;
    case "avg total case time":
      tooltip = "Avg_Total_Case_Time_Tooltip";
      conversionKey = "intlMins";
      break;
    case "room turnover time":
      tooltip = "Room_Turnover_Time_Tooltip";
      conversionKey = "intlMins";
      break;
    case "primary surgeon turnover time":
      tooltip = "Primary_Surgeon_Turnover_Time_Tooltip";
      conversionKey = "intlMins";
      break;
    default:
      tooltip = "";
      conversionKey = "intlNumber";
      break;
  }

  return { tooltip, conversionKey, title, subTitle };
}
